import React, { useState, useEffect } from "react";
import { Card, Row, Col, Collapse, Tag, Avatar, Spin, Space } from "antd";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { DashboardService } from "./services/dashboard-service";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
import { useId24 } from "../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../config/app-config";
import { numberWithCommas } from "../../utils";
const appConfig = loadAppConfig();
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;

const fontStyleRow = {
  textAlign: "left",
  fontSize: "10px",
  borderBottom: "1px solid #ddd",
} as any;

const fontStyleHerder = {
  fontSize: "18px",
  color: "#FFFFFF",
} as any;

const fontStyleTap = {
  fontSize: "14px",
  borderRadius: "10px",
} as any;

const statusConfig: any = {
  new: {
    label: "New",
    cardBg: "#0056B4",
    tagColor: "#1890FF",
    textColor: "#108ee9",
    avatarBg: "#E1EDF9",
    iconColor: "#035BBD",
  },
  action: {
    label: "Action",
    cardBg: "#70C787",
    tagColor: "#52C41A",
    textColor: "#52C41A",
    avatarBg: "#DEFFCD",
    iconColor: "#52C41A",
  },
  noAction: {
    label: "No-Action",
    cardBg: "#EE5F77",
    tagColor: "#FF4D4F",
    textColor: "#FF4D4F",
    avatarBg: "#FFE2E2",
    iconColor: "#FF4D4F",
  },
};
interface Props {
  baseUrl: string;
}

export const DashboardManagerOa: React.FC<Props> = ({ baseUrl }) => {
  const history = useHistory();
  const { id24Axios } = useId24();
  const [loading, setLoading] = useState<boolean>(true);
  const [dataSource, setDataSource] = useState<{
    new: any[];
    action: any[];
    noAction: any[];
  }>({
    new: [],
    action: [],
    noAction: [],
  });

  function integrateDashboardByStatus(data: any[], status: "new" | "action" | "noAction") {
    let listNew: any[] = [];
    let supList: any[] = [];
    let dataSource: any[] = [];

    data.forEach((x1: any) => {
      if (x1.actionstatus === status) {
        const list = {
          listname: x1.listname,
          collid: x1.collid,
          collname: x1.collname,
          cnt: x1.cnt,
          sumamt: x1.sumamt,
          sumcurbal: x1.sumcurbal,
          sumos: x1.sumos,
          sumstmtamt: x1.sumstmtamt,
          supname: x1.supname,
          manid: x1.manid,
        };
        listNew.push(list);

        const team = {
          supname: x1.supname,
          supid: x1.supid,
          listname: x1.listname,
          manid: x1.manid,
        };
        supList.push(team);
      }
    });

    // 2. groupBySup (เหมือนตัวเก่า)
    const groupBySup = listNew.reduce((group: any[], groupList: any) => {
      const { supname, listname } = groupList;
      const found = group.find((x) => x.supname === supname && x.listname === listname);

      if (found) {
        found.userlist.push(groupList);
      } else {
        group.push({
          supname,
          listname,
          userlist: [groupList],
        });
      }
      return group;
    }, []);

    const groupByTeamsForCheck = (supList: any[]) =>
      Object.values(
        supList.reduce((data: any, { supname, listname }: any) => {
          if (data[supname]) {
            if (!data[supname].list.find((l: any) => l.listname === listname)) {
              const userlist = groupBySup.find((l) => l.listname === listname && l.supname === supname);
              data[supname].list.push({ listname, userlist });
            }
          } else {
            const userlist = groupBySup.find((l) => l.listname === listname && l.supname === supname);
            data[supname] = { supname, list: [{ listname, userlist }] };
          }
          return data;
        }, {}),
      );

    const groupByTeams = (supList: any[]) =>
      Object.values(
        supList.reduce((data: any, { supname, supid, listname, manid }: any) => {
          if (data[supname]) {
            if (!data[supname].list.find((l: any) => l.listname === listname)) {
              const userlist: any = groupBySup.find((l) => l.listname === listname && l.supname === supname);

              let ac = 0,
                os = 0,
                bal = 0,
                cur = 0,
                stmt = 0;

              userlist.userlist.forEach((item: any) => {
                ac += item.cnt;
                os += item.sumos;
                bal += item.sumamt;
                cur += item.sumcurbal;
                stmt += item.sumstmtamt;
              });

              data[supname].list.push({
                listname,
                userlist,
                manid,
                ac,
                os,
                bal,
                cur,
                stmt,
              });
            }
          } else {
            const userlist: any = groupBySup.find((l) => l.listname === listname && l.supname === supname);

            let ac = 0,
              os = 0,
              bal = 0,
              cur = 0,
              stmt = 0;

            userlist.userlist.forEach((item: any) => {
              ac += item.cnt;
              os += item.sumos;
              bal += item.sumamt;
              cur += item.sumcurbal;
              stmt += item.sumstmtamt;
            });

            const list: any = {
              listname,
              userlist,
              manid,
              ac,
              os,
              bal,
              cur,
              stmt,
            };

            let acTeam = 0,
              osTeam = 0,
              balTeam = 0,
              stmtTeam = 0,
              curTeam = 0;

            const supListCheck: any = groupByTeamsForCheck(supList).find((team: any) => team.supname === supname);

            supListCheck.list.forEach((oaCount: any) => {
              oaCount.userlist.userlist.forEach((oa: any) => {
                acTeam += oa.cnt;
                osTeam += oa.sumos;
                balTeam += oa.sumamt;
                stmtTeam += oa.sumstmtamt;
                curTeam += oa.sumcurbal;
              });
            });

            data[supname] = {
              supname,
              supid,
              list: [list],
              ac: acTeam,
              os: osTeam,
              bal: balTeam,
              cur: curTeam,
              stmt: stmtTeam,
              manid,
            };
          }

          return data;
        }, {}),
      );

    const result = {
      statusName: status,
      supList: groupByTeams(supList),
    };

    dataSource.push(result);
    return dataSource;
  }

  const getSupName = (sup: string) => {
    if (sup) {
      return sup;
    } else {
      return "Unassigned";
    }
  };

  const toDebt = (status: string, supName: string, supId: string, list: string, collId: string, collName: string, manId: string) => {
    if (status) {
      let mi = manId;
      if (supId) {
        mi = "";
      }
      let all = {
        type: "OA",
        statusName: status,
        supName: supName,
        supId: supId,
        listName: list,
        collName: collName,
        collId: collId,
        manId: mi,
      };
      history.push("/debtmanagement", all);
    }
  };

  useEffect(() => {
    async function fetchDataForSearch() {
      const apiCaller = id24Axios(appConfig.apiBaseUrlDebt);
      const res: any = await DashboardService(apiCaller).getOaManager();
      let conDataNew: any = integrateDashboardByStatus(res.result, "new");
      let conDataAction: any = integrateDashboardByStatus(res.result, "action");
      let conDataNoAction: any = integrateDashboardByStatus(res.result, "noAction");
      setDataSource({
        new: conDataNew,
        action: conDataAction,
        noAction: conDataNoAction,
      });
      setLoading(false);
    }

    if (loading) fetchDataForSearch();
  }, [loading]);

  const renderStatusBlock = (status: "new" | "action" | "noAction") => {
    const conf = statusConfig[status];
    const statusData = dataSource[status];
    return statusData.map((newstatus: any, index: number) => (
      <Col span={8} key={status + index}>
        <Row>
          <Col span={24}>
            {/* ===== Header Card ===== */}
            <Card
              style={{
                backgroundColor: conf.cardBg,
                borderRadius: "5px",
                marginBottom: "10px",
                justifyContent: "center",
                display: "flex",
                gap: "24px",
              }}
            >
              <Space>
                <b style={fontStyleHerder}>{conf.label}</b>
                <Tag style={fontStyleTap} color={conf.tagColor}>
                  <NumberFormat value={newstatus.supList.length} displayType="text" thousandSeparator />
                </Tag>
              </Space>
            </Card>

            {/* ===== SUP LEVEL ===== */}
            {newstatus.supList.map((sup: any, indexSup: number) => (
              <Col key={indexSup}>
                <Collapse
                  defaultActiveKey={["0"]}
                  expandIconPosition="end"
                  style={{ borderRadius: "5px", backgroundColor: "#FFFFFF" }}
                  bordered={false}
                  ghost
                >
                  <Panel
                    key="1"
                    header={
                      <Col span={24}>
                        <Row gutter={[0, 24]}>
                          <Col span={4}></Col>
                          <Col span={18}>
                            <a
                              onClick={() => toDebt(status, sup.supname, sup.supid, "", "", "", sup.manid)}
                              style={{ fontSize: "18px", color: conf.textColor, marginRight: "5px" }}
                            >
                              <b>{getSupName(sup.supname)}</b>
                            </a>
                            <Tag style={{ fontSize: "16px", borderRadius: "10px" }} color={conf.tagColor}>
                              <NumberFormat value={sup.list.length} displayType="text" thousandSeparator />
                            </Tag>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={4}>
                            <Avatar
                              style={{ backgroundColor: conf.avatarBg }}
                              shape="square"
                              icon={<UserOutlined style={{ color: conf.iconColor }} />}
                            />
                          </Col>
                          <Col
                            span={20}
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            <div>
                              A/C <b style={{ color: "black", marginLeft: "2px" }}>{sup.ac}</b>
                            </div>
                            <div>
                              BAL <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(sup.bal)}</b>
                            </div>
                            <div>
                              OS <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(sup.os)}</b>
                            </div>
                            <div>
                              CUR <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(sup.cur)}</b>
                            </div>
                            <div>
                              STMT <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(sup.stmt)}</b>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    }
                  >
                    <Collapse defaultActiveKey={["0"]}>
                      {sup.list.map((list: any, indexList: number) => (
                        <Panel
                          key={indexList}
                          header={
                            <>
                              <Col span={8}>
                                <a
                                  style={{ color: "black", fontSize: "12px" }}
                                  onClick={() => toDebt(status, sup.supname, sup.supid, list.listname, "", "", list.manid)}
                                >
                                  {list.listname}
                                </a>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                A/C <b>{list.ac}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                BAL <b style={{ color: "#0056b4" }}>{numberWithCommas(list.bal)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                OS <b style={{ color: "#0056b4" }}>{numberWithCommas(list.os)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                CUR <b style={{ color: "#0056b4" }}>{numberWithCommas(list.cur)}</b>
                              </Col>
                              <Col span={8} style={{ fontSize: "10px" }}>
                                STMT <b style={{ color: "#0056b4" }}>{numberWithCommas(list.stmt)}</b>
                              </Col>
                            </>
                          }
                        >
                          {list.userlist.userlist.map((collector: any, index: number) => (
                            <Row style={fontStyleRow} key={index}>
                              <Col span={7} offset={1}>
                                <a
                                  style={{ color: "black" }}
                                  onClick={() =>
                                    toDebt(status, sup.supname, sup.supid, list.listname, collector.collid, collector.collname, collector.manid)
                                  }
                                >
                                  {getSupName(collector.collname)}
                                </a>
                              </Col>

                              <Col span={6} offset={2}>
                                A/C{" "}
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {collector.cnt}
                                </b>
                              </Col>
                              <Col span={6} offset={2}>
                                BAL{" "}
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {numberWithCommas(collector.sumamt)}
                                </b>
                              </Col>
                              <Col span={6} offset={1}>
                                OS{" "}
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {numberWithCommas(collector.sumos)}
                                </b>
                              </Col>
                              <Col span={6} offset={3}>
                                CUR
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {numberWithCommas(collector.sumcurbal)}
                                </b>
                              </Col>
                              <Col span={6} offset={2}>
                                STMT{" "}
                                <b
                                  style={{
                                    marginLeft: "2px",
                                    color: "#0056B4",
                                  }}
                                >
                                  {numberWithCommas(collector.sumstmtamt)}
                                </b>
                              </Col>
                            </Row>
                          ))}
                        </Panel>
                      ))}
                    </Collapse>
                  </Panel>
                </Collapse>
                <br />
              </Col>
            ))}
          </Col>
        </Row>
      </Col>
    ));
  };

  return loading ? (
    <>
      <div style={{ justifyContent: "center", display: "flex", alignItems: "center", minHeight: "30vh" }}>
        <Spin spinning={loading} tip="Loading" indicator={antIcon} />
      </div>
    </>
  ) : (
    <>
      <Row
        gutter={[
          { xs: 8, sm: 18 },
          { xs: 8, sm: 18 },
        ]}
      >
        {renderStatusBlock("new")}
        {renderStatusBlock("action")}
        {renderStatusBlock("noAction")}
      </Row>
    </>
  );
};
